const CHUNK_LOAD_ERROR = 'ChunkLoadError';

export const isChunkLoadError = (error: Error | null): boolean => {
  if (!error) {
    return false;
  }

  return (
    error.name === CHUNK_LOAD_ERROR ||
    error.message
      ?.toLowerCase()
      ?.includes('failed to fetch dynamically imported module') ||
    error.message
      ?.toLowerCase()
      ?.includes('error loading dynamically imported module')
  );
};
